module.exports = __webpack_public_path__ + "static/aca_fct3-09d66deba42804062849f52301a0f34f.jpg";